(function (module) {
  'use strict';
  module
    .controller('LoginController', ['$scope', '$state', '$stateParams', 'ngDialog', 'authService', 'members', 'obexConstant', 'obexRoles', 'clientSelectService','agencySelectService',
      function ($scope, $state, $stateParams, ngDialog, authService, members, obexConstant, obexRoles, clientSelectService,agencySelectService) {
        $scope.user = {};
        $scope.login = function () {
          if ($scope.user.email && $scope.user.password) {
            $scope.ajaxload = true;
            var emailRegex =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (emailRegex.test($scope.user.email)) {
              authService.getTokenFromCredential($scope.user.email, $scope.user.password)
            .then(response => {
                authService.setToken(response.data);
                return members.gerMemberAccount($scope.user.email);
              }, error => {

                $scope.ajaxload = false;
                const dialog = ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.errMsg = '';
                    if (error.data.error === 'invalid_grant') {
                      $scope.errMsg += '<p>You have entered invalid login credentials.</p> <p> Please try again.</p>';
                    } else if(error.data.message){
                      $scope.errMsg+=error.data.message
                    } else {
                      $scope.errMsg += '<p>Invalid email/password. Please try again.</p>';
                    }
                    $scope.errTitle = 'Login Error';
                  },],
                });
                dialog.closePromise.then(function (data) {});
              })
            .then(response => {
                $scope.ajaxload = false;
                if (response) { //Account for case if previous chained promise is rejected
                  if (response.status === 200) {
                    const loginMember = response.data;
                    if (loginMember.Role === obexRoles.roleTravelAgent) {
                      const dialog = ngDialog.open({
                        template: "templates/partials/viewErrorMsg.html",
                        className: "ngdialog-theme-plain",
                        controller: [
                          "$scope",
                          function ($scope) {
                            $scope.errMsg = `<p>Please log in to the new <a href='${obexConstant.urlAgentPortal}' target='_blank'>Advisor Chat Platform</a> using the same credentials to begin chatting with travelers.</p>`;
                            $scope.errTitle = "Login Error";
                          },
                        ],
                      });
                      dialog.closePromise.then(function (data) {});
                    } else if(loginMember.Role === obexRoles.roleUser) {
                      const dialog = ngDialog.open({
                        template: 'templates/partials/viewErrorMsg.html',
                        className: 'ngdialog-theme-plain',
                        controller: ['$scope', function ($scope) {
                          $scope.errMsg = `<p>You are not authorized. This is only for admin.</p>`;
                          $scope.errTitle = 'Login Error';
                        },],
                      });
                      dialog.closePromise.then(function (data) {});
                    } else {
                      const permission = obexConstant.permissions[loginMember.Role];
                      authService.setPermission(permission);
                      authService.setLoginMember(loginMember);
                      clientSelectService.clearSelectedClient();
                      agencySelectService.clearSelectedAgency();
                      $state.go('app');
                    }
                  } else if (response.status === 204 || response.data === '') {
                    //Account exists in AAD but not in DB
                    const dialog = ngDialog.open({
                      template: 'templates/partials/viewErrorMsg.html',
                      className: 'ngdialog-theme-plain',
                      controller: ['$scope', function ($scope) {
                        $scope.errMsg = `<p>We are unable to fully locate your account. Please contact Obex Customer Support. </p> <p>Please try again.</p>`;
                        $scope.errTitle = 'Login Error';
                      },],
                    });
                    dialog.closePromise.then(function (data) {});
                  } else {
                    const dialog = ngDialog.open({
                      template: 'templates/partials/viewErrorMsg.html',
                      className: 'ngdialog-theme-plain',
                      controller: ['$scope', function ($scope) {
                        $scope.errMsg = `<p>${err.statusText}.</p> <p>Please try again.</p>`;
                        $scope.errTitle = 'Login Error';
                      },],
                    });
                    dialog.closePromise.then(function (data) {});
                  }
                }
              }, error => {
                console.log('error ', error);
              }); } else {
              $scope.ajaxload = false;
              var dialog = ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = `<p>Please enter a valid email address.</p> <p>Ex: user@company.com</p>`;
                  $scope.errTitle = 'Login Error';
                },],
              });
              dialog.closePromise.then(function (data) {});
            }
          } else {
            $scope.ajaxload = false;
            var dialog = ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = `<p>Please enter both email and password.</p>`;
                $scope.errTitle = 'Login Error';
              },],
            });
            dialog.closePromise.then(function (data) {});
          }
        };
      },
    ]);
})(angular.module('obex'));



// WEBPACK FOOTER //
// ./client/js/controllers/loginController.js